const WEBP_QUALITY = 0.8;
const WEBP_MIME = "image/webp";

const SUPPORT_CACHE = { tested: false, supported: false };

const DUMMY_PATTERNS = [
  /dummyimage\.com/i,
  /placeholder\.com/i,
  /placehold\.it/i,
  /placekitten\.com/i,
  /via\.placeholder\.com/i,
];

function isDummyUrl(url) {
  if (!url || typeof url !== "string") return true;
  return DUMMY_PATTERNS.some(function (p) { return p.test(url); });
}

function isRealSource(url) {
  if (!url || typeof url !== "string") return false;
  if (!/^https?:\/\//i.test(url)) return false;
  return !isDummyUrl(url);
}

function deriveWebpKeyFromSourceUrl(sourceUrl) {
  try {
    var u = new URL(sourceUrl);
    var pathname = u.pathname.replace(/^\/+/, ""); // strip leading slash
    var dot = pathname.lastIndexOf(".");
    var stem = dot > 0 ? pathname.substring(0, dot) : pathname;
    return stem + ".webp";
  } catch (e) {
    return null;
  }
}

function isWebpEncodingSupported() {
  if (SUPPORT_CACHE.tested) {
    return Promise.resolve(SUPPORT_CACHE.supported);
  }
  return new Promise(function (resolve) {
    try {
      var canvas = document.createElement("canvas");
      canvas.width = 1;
      canvas.height = 1;
      canvas.toBlob(
        function (blob) {
          SUPPORT_CACHE.tested = true;
          SUPPORT_CACHE.supported = !!(blob && blob.type === WEBP_MIME);
          resolve(SUPPORT_CACHE.supported);
        },
        WEBP_MIME,
        WEBP_QUALITY
      );
    } catch (e) {
      SUPPORT_CACHE.tested = true;
      SUPPORT_CACHE.supported = false;
      resolve(false);
    }
  });
}

function encodeFileToWebp(file) {
  return createImageBitmap(file).then(function (bitmap) {
    return encodeBitmapToWebp(bitmap);
  });
}

function encodeBitmapToWebp(bitmap) {
  var canvas = document.createElement("canvas");
  canvas.width = bitmap.width;
  canvas.height = bitmap.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(bitmap, 0, 0);
  if (typeof bitmap.close === "function") {
    bitmap.close();
  }
  return new Promise(function (resolve, reject) {
    canvas.toBlob(
      function (blob) {
        if (!blob || blob.type !== WEBP_MIME) {
          reject(new Error("Browser failed to encode webp (got " + (blob && blob.type) + ")"));
          return;
        }
        resolve(blob);
      },
      WEBP_MIME,
      WEBP_QUALITY
    );
  });
}

function fetchImageAsBitmap(url) {
  return fetch(url, { mode: "cors", credentials: "omit", cache: "no-cache" })
    .catch(function (e) {
      var err = new Error(
        "Could not download image — S3 CORS may not be configured for this origin. " +
          "Add the CMS origin to the bucket's CORS allowed origins (GET/HEAD)."
      );
      err.code = "CORS_OR_NETWORK";
      err.originalError = e;
      throw err;
    })
    .then(function (response) {
      if (!response.ok) {
        throw new Error("Image download HTTP " + response.status + ": " + url);
      }
      return response.blob();
    })
    .then(function (blob) {
      return createImageBitmap(blob).catch(function (e) {
        throw new Error("Image decode failed: " + e.message);
      });
    });
}

function preflightCors(sampleUrl) {
  if (!isRealSource(sampleUrl)) {
    return Promise.resolve(true);
  }
  return fetch(sampleUrl, { mode: "cors", credentials: "omit", cache: "no-cache" })
    .then(function () { return true; })
    .catch(function () {
      var err = new Error(
        "S3 bucket CORS not configured for this origin. " +
          "Add the CMS origin to the bucket's CORS allowed origins " +
          "(allowed methods: GET, HEAD; allowed headers: *). Then try again."
      );
      err.code = "CORS_PREFLIGHT_FAILED";
      throw err;
    });
}

export {
  WEBP_QUALITY,
  WEBP_MIME,
  isDummyUrl,
  isRealSource,
  deriveWebpKeyFromSourceUrl,
  isWebpEncodingSupported,
  encodeFileToWebp,
  encodeBitmapToWebp,
  fetchImageAsBitmap,
  preflightCors,
};
